import FetchUtils from 'src/utils/fetch_utils';
import LayoutUtils from 'src/utils/layout_utils';

class EditFormSubmit {
  static buildSubmitBody(form) {
    const formData = new FormData(form);
    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      body.append(key, value);
    });
    return body.toString();
  }

  static showErrors(errorsWrap, errors) {
    if (!errorsWrap) return;
    errorsWrap.innerHTML = errors.map((error) => `<div>${error}</div>`).join('');
    LayoutUtils.show(errorsWrap);
  }

  /**
   * Callbacks: refreshDashboardShowing(uid, id), resetSpecialFlags(),
   * toggleTopMode(popup, mode), reloadCurrentPopup(popup)
   */
  static init(form, callbacks = {}) {
    const errorsWrap = form.querySelector('.js-showing-view-edit-errors');

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const updateUrl = form.dataset.updateUrl;
      if (!updateUrl) {
        return;
      }

      const submitMode = form.dataset.submitMode || 'default';
      const resetSpecialFlags = callbacks.resetSpecialFlags;
      if (submitMode !== 'lead' && resetSpecialFlags) {
        resetSpecialFlags();
      }
      form.dataset.submitMode = 'default';

      const saveButton = form.querySelector('.js-showing-view-edit-submit');
      if (saveButton) {
        saveButton.disabled = true;
      }

      if (errorsWrap) {
        LayoutUtils.hide(errorsWrap);
        errorsWrap.innerHTML = '';
      }

      const body = EditFormSubmit.buildSubmitBody(form);

      fetch(updateUrl, {
        method: (form.method || 'POST').toUpperCase(),
        headers: {
          'x-csrf-token': FetchUtils.CSRFToken(),
          accept: 'application/json',
          'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body
      })
        .then((resp) => FetchUtils.checkResponseStatus(resp))
        .then((resp) => resp.json())
        .then((response) => {
          if (!response.success) {
            const errors = response.errors || ['Unable to save showing.'];
            EditFormSubmit.showErrors(errorsWrap, errors);
            return;
          }

          const showingId = response.id;
          const showingUid = response.uid;

          callbacks.refreshDashboardShowing?.(showingUid, showingId);
          document.dispatchEvent(new CustomEvent('showing:updated', { detail: { showingId: `${showingId}` } }));
          const popup = form.closest('.js-showing-view-popup');
          callbacks.toggleTopMode?.(popup, 'readonly');
          callbacks.reloadCurrentPopup?.(popup);
        })
        .catch((err) => {
          if (FetchUtils.isValidationError(err)) {
            const errors = err?.payload?.errors || ['Unable to save showing.'];
            EditFormSubmit.showErrors(errorsWrap, errors);
            return;
          }

          if (errorsWrap) {
            errorsWrap.innerHTML = '<div>Unable to save showing. Please try again.</div>';
            LayoutUtils.show(errorsWrap);
          }
          FetchUtils.handleResponseError(err);
        })
        .finally(() => {
          if (saveButton) {
            saveButton.disabled = false;
          }
        });
    });
  }
}

export function initEditFormSubmit(form, callbacks = {}) {
  EditFormSubmit.init(form, callbacks);
}
